import CryptoJS from 'crypto-js'

import api from '@/api'
import { KEY_USER_ID } from '@/fixtures/Constants'
import { CRYPTO_KEY } from '@/fixtures/Hash'

const encUserIdKey = btoa(KEY_USER_ID)

const namespaced = true

const state = {
  users: [],
  userDetail: null,
  userId: localStorage.getItem(encUserIdKey) || null
}

const getters = {
  users: state => state.users,
  userDetail: state => state.userDetail,
  userId: state => state.userId
    ? CryptoJS.AES.decrypt(state.userId, CRYPTO_KEY).toString(CryptoJS.enc.Utf8)
    : null
}

const mutations = {
  SET_USERS: (state, payload) => {
    state.users = payload
  },
  SET_USER_DETAIL: (state, payload) => {
    state.userDetail = payload
  },
  SET_USER_ID: (state, payload) => {
    state.userId = payload
    localStorage.setItem(encUserIdKey, payload)
  }
}

const actions = {
  async fetchUsers({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...payload,
        active: payload.active
          ? eval(payload.active)
          : null,
        is_active_directory: payload.is_active_directory
          ? eval(payload.is_active_directory)
          : null,
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize
      }

      const { data } = await api.getUsers(filter)
      if (data.error) {
        commit('SET_USERS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_USERS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async fetchUserActiveDirectory({ commit }, payload) {
    try {
      const { data } = await api.getUserAd(payload)
      if (data.error) {
        commit('SET_USERS', [])
        return
      }

      commit('SET_USERS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchUserDetail({ commit }, payload) {
    try {
      const { data } = await api.getUserDetail(payload)
      commit('SET_USER_ID', CryptoJS.AES.encrypt(payload.toString(), CRYPTO_KEY).toString())
      if (data.error) {
        commit('SET_USER_DETAIL', null)
        return
      }

      commit('SET_USER_DETAIL', data)
    } catch (err) {
      throw err
    }
  },
  async postUser(_, payload) {
    try {
      const { data } = await api.postUser(payload)
      if (data && data.error) {
        return data.error
      }
    } catch (err) {
      throw err
    }
  },
  async putUser(_, payload) {
    try {
      const id = payload.id
      delete payload.id

      await api.putUser(id, payload)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteUser(_, payload) {
    try {
      await api.deleteUser(payload)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
